module.exports = __webpack_public_path__ + "76f0cf6201d35191bcb8a7e5cc15d9ad.svg";